import {useTranslation} from '@aboutyou/i18n';
import React, {FC, useState} from 'react';
import {GenericFilteredItems} from '../../FilterContent/Shared/GenericFilteredItems/GenericFilteredItems';
import {GenericFilterItemGroup} from '../../FilterContent/Shared/GenericFilteredItems/types';
import {GenericFilterSearchField} from '../../FilterContent/Shared/GenericSearchField';
import {FilterDropdown} from '../FilterDropdown';

interface Props {
  activeItemIds: Array<string>;
  dataTestId?: string;
  itemGroups: Array<GenericFilterItemGroup>;
  label: string;
  isSingleSelect?: boolean;
  onItemClick?: (itemId: string, itemSlug?: string) => void;
  onFilterReset: () => void;
  onOpen?: () => void;
  onClose?: () => void;
  showSearchField?: boolean;
  showScrollFade?: boolean;
}

export const FilterDropdownGroupedGeneric: FC<Props> = ({
  activeItemIds,
  itemGroups,
  label,
  onItemClick,
  onFilterReset,
  onOpen,
  onClose,
  showSearchField = false,
  dataTestId = 'filterDropdownGroupedGeneric',
  showScrollFade,
}) => {
  const {t} = useTranslation();
  const [search, setSearch] = useState('');

  const onCloseGenericFilter = () => {
    setSearch('');
    onClose?.();
  };

  return (
    <FilterDropdown
      dataTestId={dataTestId}
      activeCount={activeItemIds.length}
      label={label}
      onClose={onCloseGenericFilter}
      onReset={onFilterReset}
      onOpen={onOpen}
      showScrollFade={showScrollFade}
      filterContent={
        <div>
          {showSearchField && (
            <GenericFilterSearchField
              search={search}
              searchPlaceholder={t('Search for {label}', {label})}
              setSearch={setSearch}
            />
          )}
          <GenericFilteredItems
            search={search}
            activeIds={activeItemIds}
            itemGroups={itemGroups}
            onItemClick={onItemClick}
            dataTestId={dataTestId}
            enableFilterFlyout={false} // desktop version needs different styling
          />
        </div>
      }
    />
  );
};
